import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/brand-warning.png'
import _imports_1 from '../assets/images/arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-388d4784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "digital_chat_setting_content_bg" }
const _hoisted_2 = { class: "kp-wrapper welcome_message_bg" }
const _hoisted_3 = { class: "title welcome_message_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "欢迎语", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "keyword-input-wrapper" }
const _hoisted_7 = { class: "kp-wrapper" }
const _hoisted_8 = { class: "title trigger_world_title" }
const _hoisted_9 = { class: "title_left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "触发词", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "center_add_tips" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add_title" }, "添加", -1))
const _hoisted_15 = { class: "page_bg" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "page_number" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "trigger_word_content_bg" }
const _hoisted_20 = { class: "trigger_word_bg" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onMouseover", "onMouseleave"]
const _hoisted_23 = ["src", "onClick"]
const _hoisted_24 = { class: "model_library_selection_bg" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "model_tips_title" }, "大模型库", -1))
const _hoisted_26 = { class: "model_librarys" }
const _hoisted_27 = { class: "kp-option-wrapper" }
const _hoisted_28 = { class: "option-item personality_setting" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "领域知识", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_33 = {
  key: 0,
  class: "trigger_word_creat_pop_bg"
}
const _hoisted_34 = { class: "top_view" }
const _hoisted_35 = { class: "trigger_word_text_link_content_bg" }
const _hoisted_36 = { class: "trigger_word_content_bg" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trigger_word_text_title" }, "触发词", -1))
const _hoisted_38 = { class: "trigger_word_content_bg" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trigger_word_text_title" }, "触发词内容", -1))
const _hoisted_40 = { class: "trigger_word_content_bg" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trigger_word_link_title" }, "链接", -1))
const _hoisted_42 = { class: "media_content_bg" }
const _hoisted_43 = { class: "image_content" }
const _hoisted_44 = { class: "add_media_button" }
const _hoisted_45 = {
  key: 0,
  class: "media_title"
}
const _hoisted_46 = {
  key: 1,
  class: "media_center_add_tips"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = {
  key: 3,
  class: "add_media_tips"
}
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "video_content" }
const _hoisted_52 = { class: "add_media_button" }
const _hoisted_53 = {
  key: 0,
  class: "media_title"
}
const _hoisted_54 = {
  key: 1,
  class: "media_center_add_tips"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = ["src"]
const _hoisted_57 = ["src"]
const _hoisted_58 = {
  key: 3,
  class: "add_media_tips"
}
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "trigger_model_radio_bg" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trigger_model_title" }, "触发词类型", -1))
const _hoisted_62 = { class: "trigger_model_radio" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_KnowledgeListView = _resolveComponent("KnowledgeListView")!
  const _component_VideoTriggerPlayView = _resolveComponent("VideoTriggerPlayView")!
  const _component_SubViewLoadingView = _resolveComponent("SubViewLoadingView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_tooltip, {
          class: "item",
          effect: "dark",
          content: "*影响用户访问您联卡时首次看到的内容",
          placement: "top-start"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_input, {
          class: "keyword-input keyword-zh",
          placeholder: "请输入",
          modelValue: _ctx.npcDetail.welcomeMsg,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.npcDetail.welcomeMsg) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_el_tooltip, {
            class: "item",
            effect: "dark",
            content: "*当对话文本中包含触发词时将返回相应的内容",
            placement: "top-start"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "add_button",
            onClick: _ctx.triggerWordAddButtonClick
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: _ctx.addTriggerWordIcon,
                  alt: ""
                }, null, 8, _hoisted_13),
                _hoisted_14
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            disabled: _ctx.currentPage <= 1,
            class: "page_button",
            onClick: _ctx.pageLeft,
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverLeft = true)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverLeft = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.leftButtonImage,
                alt: "Left"
              }, null, 8, _hoisted_16)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentPage), 1),
          _createVNode(_component_el_button, {
            disabled: !_ctx.canPageRight,
            class: "page_button",
            onClick: _ctx.pageRight,
            onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hoverRight = true)),
            onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoverRight = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.rightButtonImage,
                alt: "Right"
              }, null, 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qaDataList, (item, index) => {
              return (_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(['trigger_word_label_bg', _ctx.triggerWordHoverIndex == index ? 'trigger_word_label_bg_hover' : '']),
                  onClick: ($event: any) => (_ctx.triggerWordLabelClick(index))
                }, [
                  _createElementVNode("span", {
                    onMouseover: ($event: any) => (_ctx.handleMouseOver(index)),
                    onMouseleave: ($event: any) => (_ctx.handleMouseLeave(index)),
                    class: "trigger_word_label"
                  }, _toDisplayString(_ctx.triggerWordHoverIndex == index ? "前往编辑" : item.keyword), 41, _hoisted_22),
                  _createElementVNode("img", {
                    class: "delete",
                    src: _ctx.circleGrayDelete,
                    alt: "",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteTriggerWord(index)), ["stop"])
                  }, null, 8, _hoisted_23)
                ], 10, _hoisted_21)
              ]))
            }), 256))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelLibraryList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_button, {
              class: _normalizeClass(['model_library_item', _ctx.selectedMobel === item ? 'model_library_item_selected' : '']),
              onClick: ($event: any) => (_ctx.modelLibraryItemClick(item)),
              disabled: !item.allow
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick", "disabled"]))
          }), 256))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_el_tooltip, {
            class: "item",
            effect: "dark",
            content: "*支持文本格式文件",
            placement: "top-start"
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "option-btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editYl && _ctx.editYl(...args)))
        }, [
          _createTextVNode(" 点击配置 "),
          _hoisted_32
        ])
      ])
    ]),
    (_ctx.showKeyWordCreatView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_BackButtonItem, {
              onBackBtnClick: _ctx.triggerWordCancelButtonClick,
              class: "back_button"
            }, null, 8, ["onBackBtnClick"]),
            _createElementVNode("button", {
              class: "submit_button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.triggerWordConfirmButtonClick && _ctx.triggerWordConfirmButtonClick(...args)))
            }, "保存")
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_el_input, {
                placeholder: "请输入触发词",
                maxlength: "300",
                modelValue: _ctx.newAddTriggerWordItem.keyword,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newAddTriggerWordItem.keyword) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(_component_el_input, {
                placeholder: "请输入触发的文本",
                maxlength: "1000",
                modelValue: _ctx.newAddTriggerWordItem.text,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newAddTriggerWordItem.text) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_component_el_input, {
                placeholder: "https://",
                maxlength: "200",
                modelValue: _ctx.newAddTriggerWordItem.linkUrl,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newAddTriggerWordItem.linkUrl) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_el_upload, {
                action: "",
                class: "upload_el_view",
                drag: "",
                accept: "image/png,image/jpeg",
                "on-error": _ctx.handleImgError,
                "on-success": _ctx.handleImgSuccess,
                "http-request": (item) => _ctx.uploadImg(item.file),
                "before-upload": _ctx.beforeImgUPload,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    (!_ctx.newAddTriggerWordItem.imgUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "上传图片"))
                      : _createCommentVNode("", true),
                    (_ctx.newAddTriggerWordItem.imgUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("img", {
                            class: "media_icon",
                            src: _ctx.newAddTriggerWordItem.imgUrl,
                            alt: ""
                          }, null, 8, _hoisted_47)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.newAddTriggerWordItem.imgUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          class: "add_img",
                          src: _ctx.addTriggerWordMedia,
                          alt: ""
                        }, null, 8, _hoisted_48))
                      : _createCommentVNode("", true),
                    (!_ctx.newAddTriggerWordItem.imgUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "JPG/PNG(2M以内)"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.newAddTriggerWordItem.imgUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "delete_upload",
                        src: _ctx.circleGrayDelete,
                        alt: "",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteUploadImage && _ctx.deleteUploadImage(...args)), ["stop"]))
                      }, null, 8, _hoisted_50))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["on-error", "on-success", "http-request", "before-upload"])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_el_upload, {
                action: "",
                class: "upload_el_view",
                drag: "",
                accept: "video/*",
                "on-error": _ctx.handleVideoError,
                "on-success": _ctx.handleVideoSuccess,
                "http-request": (item) => _ctx.uploadVideo(item.file),
                "before-upload": _ctx.beforeVideoUPload,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    (!_ctx.newAddTriggerWordItem.videoUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, "上传视频"))
                      : _createCommentVNode("", true),
                    (_ctx.newAddTriggerWordItem.videoUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("img", {
                            class: "media_icon",
                            src: _ctx.newAddTriggerWordItem.videoUrl,
                            alt: ""
                          }, null, 8, _hoisted_55),
                          _createElementVNode("div", {
                            class: "play_icon_bg",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showPlayButtonClick(_ctx.newAddTriggerWordItem.videoExtraData)), ["stop"]))
                          }, [
                            _createElementVNode("img", {
                              src: require('../assets/images/trigger_play.svg'),
                              class: "trigger_play_icon",
                              alt: ""
                            }, null, 8, _hoisted_56)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.newAddTriggerWordItem.videoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          class: "add_img",
                          src: _ctx.addTriggerWordMedia,
                          alt: ""
                        }, null, 8, _hoisted_57))
                      : _createCommentVNode("", true),
                    (!_ctx.newAddTriggerWordItem.videoUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "MP4(10M以内)"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.newAddTriggerWordItem.videoUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "delete_upload",
                        src: _ctx.circleGrayDelete,
                        alt: "",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteUploadVideo && _ctx.deleteUploadVideo(...args)), ["stop"]))
                      }, null, 8, _hoisted_59))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["on-error", "on-success", "http-request", "before-upload"])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_component_el_radio, {
                modelValue: _ctx.newAddTriggerWordItem.triggerRule,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newAddTriggerWordItem.triggerRule) = $event)),
                label: 0,
                onChange: _ctx.radioChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode("智能匹配（通过语义理解命中某问题则触发对应内容）")
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.newAddTriggerWordItem.triggerRule,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newAddTriggerWordItem.triggerRule) = $event)),
                label: 1,
                onChange: _ctx.radioChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode("精准匹配（完全包含问题则触发对应内容）")
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showKnowledgeListView)
      ? (_openBlock(), _createBlock(_component_KnowledgeListView, {
          key: 1,
          linkardId: _ctx.linkardId,
          linkardType: _ctx.linkardType,
          onDismissKnowledgeListView: _ctx.dismissKnowledgeListView
        }, null, 8, ["linkardId", "linkardType", "onDismissKnowledgeListView"]))
      : _createCommentVNode("", true),
    (_ctx.showVideoPlayTriggerView)
      ? (_openBlock(), _createBlock(_component_VideoTriggerPlayView, {
          key: 2,
          onDismissVideoTriggerPlay: _ctx.dismissVideoTriggerPlayView,
          showVideoUrl: _ctx.showVideoUrl
        }, null, 8, ["onDismissVideoTriggerPlay", "showVideoUrl"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SubViewLoadingView, { msg: _ctx.subLoadingInfo }, null, 8, ["msg"])
  ]))
}